import './VerticalNavbar.css';
import { Link, NavLink } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const VerticalNavbar = ({ onCreateClick }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="vertical-navbar">
      <div className="vertical-container">
      <Link to="/" className='brand-link'>
      <h1 className='brand'>DMYOR</h1>
      </Link>
      <ul className="navbar-nav-vn">
      <li className="nav-item-vn">
        <NavLink  to="create" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  }  onClick={onCreateClick}>
        <i className='bx bx-plus app-icons'></i>
        Create
        </NavLink>
        </li>
        <li className="nav-item-vn">
        <NavLink  to="planning" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  } >
        <i className='bx bx-notepad app-icons'></i>
        My space
        </NavLink>
        </li>
        <li className="nav-item-vn">
        <NavLink  to="search" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  } >
        <i className='bx bx-compass app-icons'></i>
        Explore
        </NavLink>
        </li>
        <li className="nav-item-vn">
        <NavLink  to="saved" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  }>
        <i className='bx bx-bookmark app-icons'></i>
        Pinned
        </NavLink>
        </li>
        <li className="nav-item-vn">
        <NavLink  to="refer" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  } >
        <i className='bx bx-gift app-icons'></i>
        Refer & earn
        </NavLink>
        </li>
        <li className="nav-item-vn">
        <NavLink  to="account" className={({ isActive, isPending }) =>
    isPending ? "pending nav-link-vn" : isActive ? "active nav-link-vn" : "nav-link-vn"
  } >
        <i className='bx bxs-user app-icons'></i>
        Me
        </NavLink>
        </li>
      </ul>

      <button className="vn-theme-toggle" onClick={toggleTheme} title="Toggle theme">
        <i className={`bx ${theme === 'dark' ? 'bx-sun' : 'bx-moon'}`}></i>
      </button>
      </div>
    </nav>
  );
};

export default VerticalNavbar;
